import type { IAnalytics, IAnalyticsProvider } from './types';

export function createAnalytics(provider: IAnalyticsProvider): IAnalytics {
  return {
    track(event, properties) {
      provider.track(event, properties);
    },
  };
}
